import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { useAuthStore, getRecoveryToken } from '../../stores/authStore';

export function Layout() {
  const { isAuthenticated, isRecovering, attemptRecovery, setLoading } = useAuthStore();

  // Attempt session recovery on app initialization (Issue #164)
  useEffect(() => {
    const initAuth = async () => {
      // Skip if already authenticated
      if (isAuthenticated) {
        setLoading(false);
        return;
      }

      // Check if there's a recovery token to try
      const recoveryToken = getRecoveryToken();
      if (recoveryToken) {
        await attemptRecovery();
      }

      setLoading(false);
    };

    initAuth();
  }, []); // Only run on mount

  // Show loading state while recovering session
  if (isRecovering) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Restoring your session...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
